import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {Store} from '@ngrx/store';
import {ExtendedFormControl} from '@aviary/forms/extensions/extended-form-control/extended-form-control';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {buildFormGroup, getExtendedControlFrom} from '@aviary/forms/form.helpers';
import {InputFormFieldComponent} from '@aviary/forms/fields/input-form-field/input-form-field.component';
import {RegistrationActions} from '@store/registration/registration.actions';
import {FALLBACK_EMAIL_VERIFICATION_REQUEST} from '@store/registration/registration.fallback';
import {RegistrationValidators} from '@store/registration/registration.validators';
import {NamedRouterLinkDirective} from '@lib/directives/named-router-link/named-router-link.directive';
import {MatCard, MatCardContent} from '@angular/material/card';
import {NgOptimizedImage} from '@angular/common';
import {FilledButtonComponent} from '@aviary/buttons/filled-button/filled-button.component';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';

@Component({
  selector: 'px-registration-email-form',
  host: {
    class: 'flex flex-row gap-x-4 items-center justify-center md:justify-between lg:pl-10 lg:pr-20'
  },
  templateUrl: './registration-email-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InputFormFieldComponent, MatCard, MatCardContent, NamedRouterLinkDirective, NgOptimizedImage, FilledButtonComponent, SelectPipe]
})
export class RegistrationEmailFormComponent {
  @Input() forLookupContext = false;

  @Input() set email(email: string) {
    this.emailFieldControl.patchValue(email);
  }

  public readonly viewportSelectors = ViewportSelectors;
  public readonly store = inject(Store);
  public readonly emailForm: ExtendedFormGroup = buildFormGroup(
    FALLBACK_EMAIL_VERIFICATION_REQUEST,
    inject(RegistrationValidators).registrationEmailFormValidator);
  public readonly emailFieldControl: ExtendedFormControl = getExtendedControlFrom(this.emailForm, 'email');

  public onClickNext() {
    this.store.dispatch(RegistrationActions.requestVerificationEmail(this.emailForm.value.email));
  }
}
